// Angular
import { NgModule } from '@angular/core';
import { MaterialModule } from 'mat-modules';
import { ControlSelectSearchComponent } from './control-select-search/control-select-search.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
//import {NgxMaterialTimepickerComponent} from './material-timepicker/ngx-material-timepicker.component'
// NgxMatSelectSearchModule
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ControlSelectSearchLoadMoreComponent } from './control-select-search-load-more/control-select-search-load-more.component';
// HTTP_INTERCEPTORS & InterceptService moved to root app.module.ts

import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';

import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

import { AppCommonElementComponent } from './app-common-element/app-common-element.component';
import { ControlDatepickerComponent } from './control-datepicker/control-datepicker.component';
import { ControlTimepickerComponent } from './control-timepicker/control-timepicker.component';
import { ControlUploadFileComponent } from './control-upload-file/control-upload-file.component';
// import { MaterialFileInputModule } from 'ngx-material-file-input';
import { MoneyPipe } from './pipe/Money';
import { ControlUploadFileDropzoneComponent } from './control-upload-file-dropzone/control-upload-file-dropzone.component';
import { NgxDropzoneModule } from 'ngx-dropzone';

@NgModule({
  declarations: [
    MoneyPipe,
    ControlSelectSearchComponent,
    ControlSelectSearchLoadMoreComponent,
    AppCommonElementComponent,
    ControlDatepickerComponent,
    ControlTimepickerComponent,
    DateRangePickerComponent,
    ControlUploadFileComponent,
    ControlUploadFileDropzoneComponent,
  ],
  exports: [
    MoneyPipe,
    ControlSelectSearchComponent,
    ControlSelectSearchLoadMoreComponent,
    //NgxMaterialTimepickerComponent
    ControlDatepickerComponent,
    ControlUploadFileComponent,
    DateRangePickerComponent,
  ],
  providers: [MoneyPipe],
  imports: [
    // material modules
    // MaterialFileInputModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    CommonModule,
    RouterModule.forChild([
      {
        path: 'appcommonelement',
        component: AppCommonElementComponent,
      },
    ]),
    NgxDropzoneModule,
    NgxDaterangepickerMd.forRoot(),
  ],
})
export class CommonElementModule {}
//dev-log
